export default {
  BASE_URL: '/psm/outstanding/arc',
  api: [
    {
      name: 'detail',
      method: 'GET',
      desc: '申报详情',
      path: '/detail'
    },
    {
      name: 'list',
      desc: '获取列表',
      method: 'GET',
      path: '/admin/list'
    },
    {
      name: 'audit',
      desc: '审核',
      method: 'PUT',
      path: '/admin/audit'
    },
    {
      name: 'review',
      desc: '评选',
      method: 'POST',
      path: '/admin/review'
    },
    {
      name: 'export',
      desc: 'excel导出',
      method: 'POST',
      path: '/admin/export'
    },
    {
      name: 'batchUpdate',
      desc: '分组信息批量更新',
      method: 'POST',
      path: '/admin/group/batchUpdate'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/api/psm/architect/index.js